import {Person} from "../../../services/interface/query/person";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import InfoOnline from "../../components/InfoOnline";
import NotPermissionComponent from "../NotPermissionComponent";
import {useFindCriminalRecords} from "../../../services/apis/apiLegalInformation";
import {CriminalRecordInterface} from "../../../services/interface/query/legal-information/criminal-record-interface";
import NoRecords from "../../components/NoRecords";
import {ItemInfo} from "../../components/ViewData";
import * as IconsMui from "@mui/icons-material";
import {formatDateString} from "../../../utils/daysOptions";

interface Props {
    person?: Person;
    sri?: boolean;
}
export default function CriminalRecord({sri, person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findLegalInformation,
        data: successLegalInformation,
        error: errorLegalInformation,
        isPending: loadingLegalInformation,
    } = useFindCriminalRecords()

    const [response, setResponse] = useState<CriminalRecordInterface | undefined>()

    const find = () => {
        if (person && person.identification && !sri) {
            setResponse(undefined);
            findLegalInformation({identifier: person.identification, msj: t('criminal-record')});
        } else if (sri && person && person?.taxIdentificationNumber) {
            setResponse(undefined);
            findLegalInformation({identifier: person?.taxIdentificationNumber, msj: t('criminal-record')});
        }
    }

    useEffect(() => {
        find();
    }, [person]);


    useEffect(() => {
        if (successLegalInformation !== undefined) {
            setResponse({
                idAntecedente: 0,
                descripcion: successLegalInformation ? 'SI' : 'NO',
                fechaActualizacion: new Date().toISOString(),
            });
        }
    }, [successLegalInformation]);


    return (
        <div className={'flex flex-col gap-3'}>
            <div className={'flex flex-row gap-2'}>
                <h3>{t('criminal-record')}</h3>
            </div>
            <NotPermissionComponent
                className={'min-h-[50px]'}
                title={'/criminal_record'}
                loading={loadingLegalInformation}
                error={errorLegalInformation}
                component={
                    <>
                        {response && !loadingLegalInformation ?
                            <div className="custom-card py-1 w-full flex items-center justify-center">
                                <div className="text-center">
                                    <ItemInfo
                                        className={`${response?.descripcion === 'SI' ? 'text-danger' : 'text-success'}`}
                                        classNameValue="font-semibold text-[18px]"
                                        label={t('record-criminal')}
                                        text={response?.descripcion}
                                        icon={<IconsMui.ContactPageTwoTone />}
                                    />
                                </div>
                            </div>
                            : <NoRecords/>
                        }
                    </>
                }
            />
        </div>
    )
}
